/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'
import usePopup from '../../hooks/usePopup'
import { ModalWindow } from '../../../../Components/GeneralComponents/ModalWindow/ModalWindow'

export default function DeleteBtn({
  user,
  onTeamUserDelete,
  onOrgUserDelete,
  onResendInvite,
  canResendInvite,
  group,
  disabled,
}) {
  const { closePopup, openPopup, isOpen } = usePopup()
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const menuRef = useRef()
  const isOrgAccess =
    group?.name === 'Organization' || user.organization_groups.length === 0
  const showResendInvite = user.is_invite_pending && canResendInvite
  const userRole = group?.roles?.[0]?.role
  const isPrivilegedRole =
    userRole === 'Organization Owner' ||
    userRole === 'Organization Administrator'

  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closePopup()
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen, closePopup])

  const executeRemove = () => {
    if (isOrgAccess) {
      onOrgUserDelete({
        o_f_id: user.organization_f_id,
        u_f_id: user.f_id,
      })
    } else {
      onTeamUserDelete({
        role: group?.roles[0].role,
        organization_users: [user.f_id],
        g_f_id: group?.f_id,
      })
    }
  }

  const handleRemoveClick = () => {
    if (isPrivilegedRole) {
      setIsConfirmOpen(true)
      closePopup()
    } else {
      executeRemove()
      setTimeout(closePopup, 500)
    }
  }

  const handleConfirm = () => {
    executeRemove()
    setIsConfirmOpen(false)
  }

  const handleResendClick = () => {
    if (onResendInvite) {
      onResendInvite({ email: user.email })
    }
    setTimeout(closePopup, 500)
  }

  const removeTitle = group
    ? isOrgAccess
      ? 'REMOVE ORG ACCESS'
      : 'REMOVE TEAM ACCESS'
    : 'REMOVE USER'

  return (
    <>
      <button
        disabled={disabled}
        onClick={openPopup}
        className={`${classes.text}`}
      >
        ...
        {isOpen && (
          <div className={classes.remove} ref={menuRef}>
            <span
              role="button"
              onClick={handleRemoveClick}
              className={classes.menuItem}
            >
              {removeTitle}
            </span>
            {showResendInvite && (
              <span
                role="button"
                onClick={handleResendClick}
                className={classes.menuItem}
              >
                RESEND INVITE
              </span>
            )}
          </div>
        )}
      </button>
      <ModalWindow
        open={isConfirmOpen}
        rounded={true}
        disableCloseIcon={true}
        onClose={() => setIsConfirmOpen(false)}
      >
        <div className={classes.modal}>
          <p className={classes['modal-title']}>
            {`Remove ${userRole === 'Organization Owner' ? 'Owner' : 'Administrator'} Access`}
          </p>
          <p className={classes['modal-subtitle']}>
            {`Please confirm you want to remove this user's ${userRole} permissions`}
          </p>
          <div className={classes['modal-actions']}>
            <button
              className={`${classes['modal-button']} ${classes['modal-button--confirm']}`}
              onClick={handleConfirm}
            >
              Confirm
            </button>
            <button
              className={`${classes['modal-button']} ${classes['modal-button--cancel']}`}
              onClick={() => setIsConfirmOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </ModalWindow>
    </>
  )
}

DeleteBtn.propTypes = {
  user: PropTypes.object,
  group: PropTypes.object,
  onTeamUserDelete: PropTypes.func,
  onOrgUserDelete: PropTypes.func,
  onResendInvite: PropTypes.func,
  canResendInvite: PropTypes.bool,
}
